import { getVendorModule } from "../vendor/runtime.js";

// Original entry module 90855 installed these before rendering the application.
getVendorModule(96395);
getVendorModule(27126);
